import { IShared } from "../../models/shared";

export const SharedState: IShared = {
  realEstateTypes: [],
  auctionStatuses: [],
};
